.monaco-editor .margin{background-color:var(--vscode-editorGutter-background)}